export default "__VITE_ASSET__Dy_O77IV__"